import {
  MASTER_THIRD_PARTY_PRICING_LIST,
  MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_LIST_FAILURE,
  MASTER_THIRD_PARTY_PRICING_CREATE,
  MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE,
  MASTER_THIRD_PARTY_PRICING_UPDATE,
  MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE,
  MASTER_THIRD_PARTY_PRICING_DELETE,
  MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE,
} from "./actionType";

// MASTER_THIRD_PARTY_PRICING_LIST
export const masterThirdPartyPricingList = () => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_LIST,
  };
};
export const masterThirdPartyPricingListSuccess = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS,
    payload: data,
  };
};
export const masterThirdPartyPricingListFailure = (error) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_LIST_FAILURE,
    payload: error,
  };
};

// MASTER_THIRD_PARTY_PRICING_CREATE
export const masterThirdPartyPricingCreate = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_CREATE,
    payload: data,
  };
};
export const masterThirdPartyPricingCreateSuccess = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS,
    payload: data,
  };
};
export const masterThirdPartyPricingCreateFailure = (error) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE,
    payload: error,
  };
};

// MASTER_THIRD_PARTY_PRICING_UPDATE
export const masterThirdPartyPricingUpdate = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_UPDATE,
    payload: data,
  };
};
export const masterThirdPartyPricingUpdateSuccess = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS,
    payload: data,
  };
};
export const masterThirdPartyPricingUpdateFailure = (error) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE,
    payload: error,
  };
};

// MASTER_THIRD_PARTY_PRICING_DELETE
export const masterThirdPartyPricingDelete = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_DELETE,
    payload: data,
  };
};
export const masterThirdPartyPricingDeleteSuccess = (data) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS,
    payload: data,
  };
};
export const masterThirdPartyPricingDeleteFailure = (error) => {
  return {
    type: MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE,
    payload: error,
  };
};
